//import $ from 'jquery';

export function initCustomFeatures() {
  if (typeof window.jQuery !== 'undefined') {
    console.log('jQuery loaded from CDN:', window.jQuery.fn.jquery);

    var cardSlider = new Swiper(".card-slider", {
          grabCursor: true,
          speed: 400,
          loop: true,
          mousewheel: {
            invert: false,
          },
          navigation: {
            nextEl: '.cc-next',
            prevEl: '.cc-prev'
          },
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
          },
          slidesPerView: 4,
          spaceBetween: 10,
          breakpoints: {
            1200: {
              slidesPerView: 4,
            },
            1025: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 2,
            },
            300: {
              slidesPerView: 1,
            },
          },
      });

    // Store all Vimeo players
    let vimeoPlayers = [];

    document.querySelectorAll('.vimeo-iframe').forEach((iframe) => {
      const player = new Vimeo.Player(iframe);
      vimeoPlayers.push(player);
    });

    document.querySelectorAll('.vimeo-player-container').forEach((container) => {
      const videoId = container.dataset.vimeoId;

      const options = {
        id: videoId,
        responsive: true,
        title: false,
        byline: false,
        portrait: false
      };

      const player = new Vimeo.Player(container, options);

      player.ready().then(() => {
        console.log(`Vimeo video ${videoId} is ready`);
      });

      vimeoPlayers.push(player);
    });

    var videoSlider = new Swiper(".watch-upto-slider", {
      grabCursor: true,
      speed: 400,
      mousewheel: {
        invert: false,
      },
      navigation: {
            nextEl: '.w-next',
            prevEl: '.w-prev'
        },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      slidesPerView: 1,
      spaceBetween: 10,
      // Hook into slide change event
      on: {
        slideChange: function () {
          vimeoPlayers.forEach((player) => {
            player.pause().catch(() => {}); // In case video is not playing
          });
        }
      }
    });

    var entradansSlider = new Swiper(".entradans-slider", {
      grabCursor: true,
      speed: 400,
      mousewheel: {
        invert: false,
      },
      navigation: {
        nextEl: '.e-next',
        prevEl: '.e-prev'
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      slidesPerView: 1,
      spaceBetween: 10,
    });

  } else {
    console.error('jQuery not loaded!');
  }
}

export function showToast(message) {
  // Simple example using jQuery
  console.log(message);
}
